// extracted by mini-css-extract-plugin
export var body = "_kk-8";
export var button = "_kk-0";
export var closeButton = "_kk-5";
export var content = "_kk-3";
export var empty = "_kk-f";
export var grid = "_kk-c";
export var header = "_kk-4";
export var icon = "_kk-1";
export var option = "_kk-d";
export var optionSelected = "_kk-e";
export var overlay = "_kk-2";
export var searchIcon = "_kk-a";
export var searchInput = "_kk-b";
export var searchWrapper = "_kk-9";
export var title = "_kk-6";
export var visuallyHidden = "_kk-7";